module.exports = __webpack_public_path__ + "img/icon-20.1b600f7d.png";